import store from '@/store';

export default class Event {
  static getEventId(route) {
    if (route.params.event_id != null && route.params.event_id > 0) {
      return route.params.event_id;
    }
    return store.getters['event/currentEventId'];
  }
}
